/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { FieldError, UseFormRegisterReturn } from 'react-hook-form';
import styled from 'styled-components';
import tw from 'twin.macro';

export type ButtonBarItem = {
  label: string;
  value: string;
};

type ButtonBarPropTypes = {
  items: ButtonBarItem[];
  register: UseFormRegisterReturn;
  validation?: FieldError;
  onChange?: (item: ButtonBarItem) => void;
};

const ButtonBarStyled = styled.div`
  input {
    width: 1px;
    height: 1px;
    visibility: hidden;
    position: absolute;
  }

  input:checked + label {
    ${tw`bg-blue-100 border-blue-100 text-black`}
  }
`;

export default function ButtonBar({
  items,
  register,
  validation,
  onChange,
}: ButtonBarPropTypes): JSX.Element {
  const { onChange: registerOnChange, ...restRegister } = register;
  return (
    <ButtonBarStyled>
      <div className="wrapper inline-flex flex-wrap flex-row mt-3">
        {items.map((item) => (
          <div className="radio-wrapper mr-3 self-start mb-5" key={item.value}>
            <input
              {...restRegister}
              id={`${register.name}-${item.value}`}
              type="radio"
              onChange={(e) => {
                registerOnChange(e);
                if (onChange) {
                  onChange(item);
                }
              }}
              value={item.value}
            />
            <label
              className="text-white flex btn btn--secondary-outline"
              htmlFor={`${register.name}-${item.value}`}>
              {item.label}
            </label>
          </div>
        ))}
      </div>
      {validation && <div className="text-red-500 my-5">Please select a movie date</div>}
    </ButtonBarStyled>
  );
}
